// @theme component
export enum actionTypes {
    PRAGMATIC_SET_TABLE_DATA = 'PRAGMATIC:TABLE_DATA:SET',
}
